export default __webpack_public_path__ + "static/media/karate.66fa8003.svg";